import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import ReceiptsSettings from '~Scenes/Settings-v2/Scenes/Receipts';
import { useI18n } from '~Hooks';

/** Handheld shell around the shared Settings-v2 receipts scene */
const Page = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.ReceiptsTitle')}>
      <ReceiptsSettings isHandy />
    </HandyPageWrapper>
  );
};

export default Page;
